import React, { FunctionComponent } from "react";

import { ScriptOrbee } from "./ScriptOrbee";

export const ExternalScripts: FunctionComponent = () => {
  return (
    <>
      <ScriptOrbee />
    </>
  );
};
